import React, { FC, memo, useEffect } from 'react';
import { ImageSize } from '@utils/Image.utils';
import CarGalleryListItem from './CarGalleryListItem';
import { ButtonGroup } from '@components/CarGallery/CarGalleryButtonGroup';
import Carousel from 'react-multi-carousel';
import { INameplateImage } from 'src/interfaces/IOfferItem';
import isEmpty from 'lodash/isEmpty';

const responsive = {
    allDevices: {
        breakpoint: { max: 4000, min: 0 },
        items: 1,
    },
};

const CarGalleryList: FC<{
    images: INameplateImage[];
    arrows: boolean;
    defaultArrows?: boolean;
    setSmallImage?: boolean;
    dots?: boolean;
}> = memo(({ images, arrows, defaultArrows = false, setSmallImage = false, dots = true }) => {
    const sortedImages = images.sort((a, b) => {
        if (!isEmpty(a.default) && isEmpty(b.default)) {
            return -1;
        } else if (isEmpty(a.default) && !isEmpty(b.default)) {
            return 1;
        } else {
            return 0;
        }
    });

    useEffect(() => {
        if (sortedImages?.length > 0) {
            document
                ?.getElementsByClassName('react-multiple-carousel__arrow--left')?.[0]
                ?.setAttribute('data-testid', 'TESTING_IMAGE_CAROUSEL_ARROW_LEFT');
            document
                ?.getElementsByClassName('react-multiple-carousel__arrow--right')?.[0]
                ?.setAttribute('data-testid', 'TESTING_IMAGE_CAROUSEL_ARROW_RIGHT');
        }
    }, [sortedImages]);

    return (
        <Carousel
            responsive={responsive}
            ssr
            showDots={dots}
            arrows={defaultArrows}
            customButtonGroup={arrows ? <ButtonGroup /> : undefined}
            slidesToSlide={1}
            infinite
            containerClass="container-with-dots"
            itemClass="car-item-wrapper"
        >
            {sortedImages.map((image: INameplateImage, index: number) => {
                return (
                    <CarGalleryListItem
                        key={index}
                        url={image.url}
                        quality={setSmallImage ? ImageSize.MEDIUM : ImageSize.EXTRA_LARGE}
                    />
                );
            })}
        </Carousel>
    );
});
CarGalleryList.displayName = 'CarGalleryList';
export default CarGalleryList;
